export default () => ({
  status: null,
  isPartner: null,
  partnerStatus: null,
  identStatus: null,
  identIsPartner: null,
  identPartnerStatus: null
})
